<div class="ir-item-line th-filter-modal">
  <div (click)="setOrderBy('name')" class="ir-item-cell s4 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.name' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('description')" class="ir-item-cell s4 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.description' | translate }}
    </span>
  </div>
</div>
<div class="ir-content-flow has-filter th-content-flow--dark has-footer">
  <div *ngIf="inspections">
    <div
      class="ir-item-line th-model indent clickable"
      [ngClass]="selectedInspection?.id == inspection.id ? 'selected' : ''"
      *ngFor="let inspection of inspections | orderBy: orderByFieldName:direction | searchBy: query"
      (click)="selectInspection(inspection)"
    >
      <div class="ir-item-cell s4">
        <div class="ir-item-selector">
          <i class="material-icons">content_paste</i>
        </div>
        <span>{{ inspection.name }}</span>
      </div>
      <div class="ir-item-cell s6">
        <span *ngIf="inspection.description">{{ inspection.description }}</span>
        <span *ngIf="!inspection.description">{{ 'common.no-description' | translate }}</span>
      </div>
    </div>
  </div>
  <div class="ir-item-empty ir-mv2" *ngIf="!inspections">
    <p>
      <span>{{ 'models.no-inspections' | translate }}</span>
    </p>
  </div>
</div>
